import UniversalSearchBox from '../explorer/UniversalSearchBox';

function TxDetailsPageHeader({ title = 'Transaction Details' }) {
  return (
    <div className="eth-tx-page-header">
      <h1 className="eth-tx-page-title">{title}</h1>
      <UniversalSearchBox
        className="eth-tx-page-search"
        inputClassName="hero-search eth-tx-page-search__input"
        placeholder="Search by Address / Txn Hash / Block / Token"
      />
    </div>
  );
}

export default TxDetailsPageHeader;
